export default __webpack_public_path__ + "static/media/Federleicht.6d237f43.mp4";